'use client';

import Skeleton from '@carvana/ds-skeleton';
import { isSuccess, type Result } from '@carvana/merch-result';
import { use } from 'react';
import { z } from 'zod';
import { usePricingUpdate } from '~/context/flp-rsc/PricingUpdateContext';
import { PricingAggregates } from '~/contracts/flp';
import { Text } from './YourTerms.styles';

const MinCashDownSchema = z.object({ downPayment: z.number() });

type OwnProps = {
  resultPromise: Promise<Result<PricingAggregates> | undefined>;
};

export default function MinCashDownValue({ resultPromise }: OwnProps) {
  const { isPending } = usePricingUpdate();

  if (isPending) {
    return <Skeleton width={110} height={32} className="rounded-md" />;
  }

  const result = use(resultPromise);

  if (!result || !isSuccess(result)) {
    return <Text>—</Text>;
  }

  const parsed = MinCashDownSchema.safeParse(result.content.minDownVehicle);

  if (!parsed.success) {
    return <Text>—</Text>;
  }

  const { downPayment } = parsed.data;

  return (
    <Text>
      {downPayment.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
      })}
    </Text>
  );
}
